// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.max-height-60[data-v-65d59982] {\n  max-height: 25rem;\n}\n.overflow-y-scroll[data-v-65d59982] {\n  overflow-y: auto;\n}\n.no-list-style[data-v-65d59982] {\n  list-style-type: none;\n  padding-left: 0;\n  max-height: 25rem;\n  overflow-y: auto;\n}\n.custom-bg-gray[data-v-65d59982] {\n  background-color: #202225;\n}\n.custom-text-gray[data-v-65d59982] {\n  color: #e0e5ec;\n}\n", ""]);
// Exports
module.exports = exports;
